import '../../libs/backbone/backbone.ajaxq.adapter.ts';
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/tickets.template.htm';
import Table from 'text-loader!../templates/tickets_table.template.htm';
import Collection from '../models/tickets.paginated.collection.ts';
import Model from '../models/tickets.model.ts';
import 'dhtmlxMessage';
import Pagination from '../views/pagination.view.ts';
import HandlebarsHelpers from '../../libs/handlebars/handlebars-helpers.ts';
import '../../libs/bootstrap/js/bootstrap-table.js';
import i18n  from "l10n";
import popup from 'popup';
import 'jqueryUI';
import TicketRowPartialTemplate from 'text-loader!../templates/partial_templates/ticketRow.partial.template.html';

import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

export default GenericView.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	ticketRowPartialTemplate: Handlebars.compile(TicketRowPartialTemplate),
	progressTemplate: Handlebars.compile("{{> progressPartial}}"),
	table: Handlebars.compile(Table),
	superInitialize: GenericView.prototype.initialize,
	collection: null,
	model: null,
	isFirstDisplay: true,
	lastSearchedText: "",
	queueTicketStompSubscriptions: {},
	initialize: function () {
		var self = this;

		this.collection = new Collection();
		this.collection.state.pageSize = 999;
		this.collection.on( 'sync', this.successData, this );
		this.collection.on( 'error', this.errorData, this );

		this.collection.url = 'rest/api/admin/tickets';
		this.collection.getFirstPage();

		this.setListener(); // stomp listener
	},
	superRender:  GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;
		this.$el.html(this.template());
	},
	events: {
	    "click .queueAccordion": "loadTicketsForQueue"
        //"keyup #search": "search"
	},
	/*search: function(event)
	{
		element = $(event.currentTarget);
		var text = element.val().trim();

        if(this.lastSearchedText != text )
        {
			$.ajaxq.abort("DefaultQueue");
			this.lastSearchedText = text;
			this.collection.url = 'rest/api/users?q=' + encodeURIComponent("lastname="+element.val().trim());
			this.collection.getFirstPage();
		}
	},*/
	unsubscribeStomp: function(self, queueId) { //toDo: use it
	    self.queueTicketStompSubscriptions[queueId].unsubscribe();
	    self.queueTicketStompSubscriptions[queueId] = null;
	},
	subscribeToStomp: function(self, queueId) {
	    if(self.queueTicketStompSubscriptions[queueId] != null) // already subscribed
	        return;

        self.queueTicketStompSubscriptions[queueId] = self.client.subscribe('/live/monitors/tickets/' + queueId, function (message){
            var responseObject = JSON.parse( message.body );
            if(responseObject.tickets != null && responseObject.tickets.length > 0) {
                var $ticketsContainer = $("#queue-"+responseObject.queueId);
                self.renderTickets($ticketsContainer, responseObject.tickets);
            }else {
                var $ticketContainer = $("#queue-"+responseObject.queueId).find("#ticket-"+responseObject.ticketId);
                self.renderSpecificTicket($ticketContainer, responseObject.ticket);
            }
        });
    },
    setListener: function()
    {
        var self = this;

        this.wsocket = new SockJS('rest/live');
        this.client = Stomp.over(this.wsocket);

        var headers = {
            //origin: 'https://www.qedis-metro.com', toDo: enable it
        };

        this.client.connect(headers,
            function(frame) {
                //self.subscribeToStomp(self);
            },
            function(onCloseMessage) {
                if(onCloseMessage.indexOf('Whoops! Lost connection to') > -1) {
                    //
                    console.log("connection closed");
                }
            }
        );
    },
	successData: function()
	{
		var self = this;
		self.hideActionProgressBar();

		if(this.isFirstDisplay)
		{
			this.isFirstDisplay = false;
			this.render();
            if(this.collection.models.length == 0)
                $('#search-container').hide();
		}

		$('#table-container').html(this.table({ "orgs" : this.collection.models, pageInfo : this.collection.info()}));

		this.pagination = new Pagination({ collection : this.collection });
		this.pagination.render();
		$( '#pagination' ).html( this.pagination.$el );

        $("#pageSize li").on("click", function() {

            var pageSize = $(this).text();

            if ( ! $(this).hasClass("active")  )
            {
                $("#pageSize li.active").removeClass("active");
                $(this).addClass("active");
                $("#pageSizeBtn").text(pageSize);
                self.collection.state.pageSize = pageSize;

                self.collection.getFirstPage();
            }

        });

		if(this.collection.models.length > 0)
		{
			$('#table-container').show();

			// if it has only one page
			if(this.collection.state.firstPage == this.collection.state.lastPage)
			    $('#pagination').hide();
			else
			    $('#pagination').show();
			$('#empty').hide();

            //self.initializeTrs(this.showHideActionButton, "#dataTables");
		}
		else
		{
			$('#table-container').hide();
			$('#pagination').hide();
			$('#empty').show();
		}

		this.$el.find(".accordion").accordion({
		    collapsible: true,
		    active: false
		});
	},
	errorData: function(collection, xhr, options)
	{
 		this.onErrorHandler(collection, xhr, options);
	},
	renderTickets: function($ticketsContainer, data) {
	    var self = this;

	    $ticketsContainer.empty();
        for(var i=0; i<data.length; i++)
            $ticketsContainer.append(self.ticketRowPartialTemplate( data[i] ));
	},
	renderSpecificTicket: function($ticketRow, data) {
	    var self = this;

	    if($ticketRow == null && $ticketRow.length == 0)
	        return;

	    $ticketRow.replaceWith(self.ticketRowPartialTemplate(data));
	},
	loadTicketsForQueue: function(e) {
	    const self = this;
	    const $elem = $(e.currentTarget);

        if(!$elem.hasClass("ui-accordion-header-active")) // closing the accordion
            return;

        const $ticketsContainer = $($elem.parent().find(".ticketsContainer")[0]);
	    var queueId = $elem.data("queue");
        self.subscribeToStomp(self, queueId);

        $ticketsContainer.empty();

        var tr = $("<tr/>");
        tr.css("display", "block");
        tr.html(self.progressTemplate());
        $ticketsContainer.append(tr);

	    $.ajaxDefaultQ({
        	url: this.collection.url + "/" + queueId,
        	type: 'GET',
        }).done(function(response, status, xhr){
        	if(status == "success")
        	{
        	    if(response.data.length > 0) {

        	        self.renderTickets($ticketsContainer, response.data);
        		} else
        		    $ticketsContainer.text(i18n.t('tickets.no_tickets'));
        	}else {
        	    console.error("Error while getting tickets for Queue ("+ queueId +")");
        	}
        })
        .fail(function(response) {
            console.error("Error while getting tickets for Queue ("+ queueId +")", response);
        });
	}
});

